import SearchIcon from "../../../assets/icons/search-icon.svg";
import styled from "styled-components";
import PropTypes from "prop-types";

const TextSearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  height: 2.75rem;
  margin-top: 0.5rem;
  width: ${(props) => (props.width ? props.width : "15rem")};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;

  & img {
    width: 1rem;
  }

  & input {
    border: none;
    max-width: 93%;
    font-size: 0.75rem;
    font-family: "neue-haas-grotesk-text";
    margin-left: 0.2rem;
    width: ${(props) => (props.width ? props.width : "15rem")};
    text-overflow: ellipsis;
    &:focus {
      outline: none;
    }
    &::placeholder {
      font-size: 0.875rem;
    }
  }
  @media (min-width: 1440px) {
    width: 24.375rem;
  }
`;

const TextSearchLabel = styled.label`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
`;

function SearchFilterRedesign({ placeHolder, searchText, handleTextSerach, width, label, dynamicAriaLabel }) {
  return (
    <div style={{ width: width }}>
      <TextSearchLabel>{label}</TextSearchLabel>
      <TextSearchWrapper role="search" width={width} aria-label={searchText.trim().length > 0 ? `${dynamicAriaLabel} cases are filtered out in the below table` : "Search"} aria-live="assertive">
        {searchText.trim().length === 0 && <img aria-hidden="true" role="img" aria-label="Search Icon" alt="" src={SearchIcon} />}
        <input id="search-filter-input" type="text" placeholder={searchText.trim().length > 0 ? `${dynamicAriaLabel} cases are filtered out in the below table` : placeHolder} value={searchText} onChange={handleTextSerach} />
      </TextSearchWrapper>
    </div>
  );
}

SearchFilterRedesign.propTypes = {
  placeHolder: PropTypes.string,
  searchText: PropTypes.string,
  handleTextSerach: PropTypes.func,
  width: PropTypes.string,
  label: PropTypes.string,
  dynamicAriaLabel: PropTypes.string
};

export default SearchFilterRedesign;
